import React, { FC, ReactNode } from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

type Props = {
  classNames?: string | string[];
  children?: ReactNode;
};

export const Label: FC<Props> = ({ classNames, children }) => {
  return (
    <StyledWrapper className={classnames(classNames)}>{children}</StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  font-size: 1rem;
  color: #ff981a;
  line-height: 1;
  margin-top: 7px;
  display: inline-block;

  &.parallel-elem {
    margin: 0.75rem 0 1rem;
  }
`;
